import apiFetch from '../apiFetch'

export default function (idTipoInstalacion, token) {
  return apiFetch({endPoint: `TipoInstalacion/deleteTipoInstalacion`, method: 'POST', body: {idTipoInstalacion}, token: token})
}
